export default class Base {
	constructor(props) {
		this.props = props || {};
	}

	init() {
		this.addEventListeners();
	}

	addEventListeners() {}
}